import $ from 'jquery';
import modal from '../../smartpak/modal.js';

let $wishList;

const wishList = {
    init: function() {
        this._bindUIEvents();
    },

    _loadResults: function(html) {
        $wishList.html(html);
    },

    _bindUIEvents: function() {
        $('.wishlistLink').on(
            'click',
            'a',
            function(e) {
                e.preventDefault();
                this._addToWishList($(e.currentTarget));
            }.bind(this)
        );
    },

    _addToWishList: function(element) {
        var productclassId = element.attr('data-productclassid'),
            productid = element.attr('data-productid'),
            url = element.attr('data-posturl'),
            data = $.param({
                productclassId: productclassId,
                selectedProductId: productid
            });

        $.post(url, data).done(this._show.bind(this));
    },

    _show: function(html) {
        $wishList = $('#wishListContent');
        this._loadResults(html);
        modal($wishList.get(0), {
            width: '450px',
            title: 'Added to My Wishlist'
        });
    }
};

export default wishList;
